<template>
  <van-image-preview
    v-model="show"
    :images="images"
    :start-position="currentIndex"
    @change="changePreview"
    @close="closePreview"
    class-name="sku-preview"
    close-on-popstate
  >
    <template #cover>
      <div class="w-100">
        <div
          v-if="currentSku.sku_name"
          class="color-F f14 flex jc-c sku_name pos-f l0 r0 pl10 pr10"
          :style="{ marginTop: screenWidth / 2 + 10 + 'px' }"
        >
          <span class="pl10 pr10 pt2 pb2 d-ib text_shadow box_shadow over-ell-2">
            {{ currentSku.sku_name }}
          </span>
        </div>
        <div
          class="flex ai-c jc-sb w-100 pl10 pr10 pt10 footerIOS"
          v-if="!hidePrice || !hideAddCartButton || !hideBuyButton"
        >
          <div class="sku-price color-F f16 mr10 text_shadow" v-if="!hidePrice">
            ¥{{ currentSku.sales_price || '0.00' }}
          </div>
          <div class="flex flex-1 buttonBox mt6 over-h">
            <van-button
              v-if="!hideAddCartButton"
              class="button shopcart flex-1"
              type="primary"
              color="linear-gradient(90deg, rgba(255, 167, 0, 1) 0%, rgba(255, 186, 0, 1) 100%)"
              @click="addToCart"
            >
              加入购物车
            </van-button>
            <van-button
              v-if="!hideBuyButton"
              class="button buy flex-1"
              type="primary"
              color="linear-gradient(90deg, rgba(252, 3, 36, 1) 0%, rgba(255, 20, 79, 1) 100%)"
              @click="buyNow"
            >
              立即购买
            </van-button>
            <van-button
              v-if="showSellOutButton"
              class="button buy flex-1"
              type="primary"
              color="#e3e3e3"
            >
              已售罄
            </van-button>
          </div>
        </div>
      </div>
    </template>
  </van-image-preview>
</template>

<script>
import { ImagePreview } from 'vant'

export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  props: {
    skuList: {
      type: Array,
      default: () => []
    },
    hidePrice: {
      type: Boolean,
      default: false
    },
    hideAddCartButton: {
      type: Boolean,
      default: false
    },
    hideBuyButton: {
      type: Boolean,
      default: false
    },
    showSellOutButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      currentIndex: -1,
      screenWidth: 0 // 新增属性
    }
  },
  mounted() {
    this.screenWidth = window.innerWidth // 获取屏幕宽度
  },
  computed: {
    images() {
      if (this.currentIndex == -1) {
        return []
      } else {
        return this.skuList.map((item) => item.spec_imgpath)
      }
    },
    currentSku() {
      return this.currentIndex >= 0 ? this.skuList[this.currentIndex] : {}
    }
  },
  methods: {
    showPreview(index) {
      this.currentIndex = index
      this.show = true
    },
    hidePreview() {
      this.show = false
    },
    closePreview({ index }) {
      this.show = false
      this.$emit('close', index)
    },
    changePreview(index) {
      this.currentIndex = index
      this.$emit('change', index)
    },
    addToCart() {
      // Add to cart logic
      console.log('Added to cart:', this.currentSku)
      this.$emit('previewAddToCart', this.currentSku)
    },
    buyNow() {
      // Buy now logic
      console.log('Buy now:', this.currentSku)
      this.$emit('previewBuyNow', this.currentSku)
    }
  }
}
</script>

<style scoped>
.sku-price {
  width: 25%;
}
.buttonBox {
  height: 0.38rem;
  border-radius: 0.19rem;
  margin-bottom: 0.07rem;
}
.button {
  height: 100%;
  color: #fff;
  font-size: 0.16rem;
  line-height: 0.38rem;
  border-radius: 0;
  text-align: center;
}
.sku_name {
  top: 50%;
}
.sku_name span {
  border: 0.01rem solid #fff;
}
.text_shadow {
  text-shadow: 0 0.01rem 0.01rem #323233;
}
.box_shadow {
  box-shadow: 0 0 0 0.01rem #323233;
}
</style>



// WEBPACK FOOTER //
// src/components/common/skuPreview.vue